var QRCode = require('qrcode.react');

function QrCodeGenerator(props: any) {


    return (<QRCode value={props.keyGenerator} />);
}

export default QrCodeGenerator;